import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { ArrowUp, ArrowDown, Plus, Trash2 } from "lucide-react";
import { EmailColumnRow } from "./EmailColumnRow";

const move = (arr, i, d) => {
  const j = i + d;
  if (j < 0 || j >= arr.length) return arr;
  const out = [...arr];
  [out[i], out[j]] = [out[j], out[i]];
  return out;
};

const SCORE_KPIS = [["activations", "Activations"], ["upgrades", "Upgrades"], ["edge", "Edge"], ["tablets", "Tablets"],
  ["fwa", "FWA"], ["twp_plus", "TWP+"], ["topups", "Top Ups"], ["autopay", "AutoPay"]];

const ScorecardEditor = ({ sec, idx, onChange }) => {
  const toggle = (k) => onChange({ ...sec, kpis: sec.kpis.includes(k) ? sec.kpis.filter((x) => x !== k) : SCORE_KPIS.map(([x]) => x).filter((x) => x === k || sec.kpis.includes(x)) });
  return (
    <div className="border border-slate-200 rounded-lg p-3 space-y-2" data-testid={`vz-email-section-${idx}`}>
      <Input className="h-8 text-sm font-semibold" value={sec.title} onChange={(e) => onChange({ ...sec, title: e.target.value })} data-testid={`vz-email-section-${idx}-title`} />
      <p className="text-xs text-slate-500">KPI scorecard per store: Goal, Current, Pacing and % to Goal rows. Goals come from Store Goals.</p>
      <div className="flex flex-wrap gap-3">
        {SCORE_KPIS.map(([k, l]) => (
          <label key={k} className="flex items-center gap-1.5 text-xs cursor-pointer">
            <input type="checkbox" checked={sec.kpis.includes(k)} onChange={() => toggle(k)} data-testid={`vz-email-section-${idx}-kpi-${k}`} /> {l}
          </label>
        ))}
      </div>
    </div>
  );
};

export const EmailSectionEditor = ({ sec, idx, kind, columns, canAdd, onChange, onMove, onRemove }) => {
  if (sec.type === "scorecard") return <ScorecardEditor sec={sec} idx={idx} onChange={onChange} />;
  const cols = sec.columns;
  const setCols = (c) => onChange({ ...sec, columns: c });
  const addCol = () => setCols([...cols, { label: columns[0] || "New column", source: { type: "raw", column: columns[0] || "" }, format: "number" }]);
  return (
    <div className="border border-slate-200 rounded-lg p-3 space-y-2" data-testid={`vz-email-section-${idx}`}>
      <div className="flex items-center gap-2">
        <Input className="h-8 text-sm font-semibold" value={sec.title} onChange={(e) => onChange({ ...sec, title: e.target.value })} data-testid={`vz-email-section-${idx}-title`} />
        {canAdd && <>
          <Button size="icon" variant="ghost" className="h-8 w-8" onClick={() => onMove(idx, -1)} data-testid={`vz-email-section-${idx}-up`}><ArrowUp className="w-4 h-4" /></Button>
          <Button size="icon" variant="ghost" className="h-8 w-8" onClick={() => onMove(idx, 1)} data-testid={`vz-email-section-${idx}-down`}><ArrowDown className="w-4 h-4" /></Button>
          <Button size="icon" variant="ghost" className="h-8 w-8 text-red-500" onClick={() => onRemove(idx)} data-testid={`vz-email-section-${idx}-remove`}><Trash2 className="w-4 h-4" /></Button>
        </>}
      </div>
      <div className="space-y-1.5">
        {cols.map((c, i) => (
          <EmailColumnRow key={i} col={c} idx={i} kind={kind} columns={columns} testid={`vz-email-s${idx}-col-${i}`}
            onChange={(nc) => setCols(cols.map((x, k) => (k === i ? nc : x)))}
            onMove={(ci, d) => setCols(move(cols, ci, d))} onRemove={(ci) => setCols(cols.filter((_, k) => k !== ci))} />
        ))}
      </div>
      <Button size="sm" variant="outline" onClick={addCol} data-testid={`vz-email-section-${idx}-add-col`}><Plus className="w-3.5 h-3.5 mr-1" /> Add column</Button>
    </div>
  );
};

export { move };
